export const today = () => new Date().toLocaleDateString('sv-SE', { timeZone: 'Europe/Podgorica' });
export const plusDays = (iso, n) => { const d = new Date(`${iso}T12:00:00Z`); d.setUTCDate(d.getUTCDate() + n); return d.toISOString().slice(0, 10); };
export const dateObj = (iso) => new Date(`${iso}T12:00:00Z`);
export const isWeekend = (iso) => [0, 6].includes(dateObj(iso).getUTCDay());
export const fmtLong = (iso) => dateObj(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
export const fmtMonth = (iso) => dateObj(iso).toLocaleDateString('en-US', { month: 'short', year: 'numeric', timeZone: 'UTC' });
export const fmtWeekday = (iso) => dateObj(iso).toLocaleDateString('en-US', { weekday: 'short', timeZone: 'UTC' });
export const fmtDay = (iso) => iso.slice(8, 10);
export const monthStart = (iso) => `${iso.slice(0, 7)}-01`;
export const monthEnd = (iso) => { const d = dateObj(monthStart(iso)); d.setUTCMonth(d.getUTCMonth() + 1); d.setUTCDate(0); return d.toISOString().slice(0, 10); };
export const rangeDays = (from, to) => { const out = []; let d = from; while (d <= to) { out.push(d); d = plusDays(d, 1); } return out; };

// Booking.com room status per night: Open (bookable), Sold out (no units left, all booked) or Closed (manually zeroed).
export const dayStatus = (d, booked, units) => {
  if (!d || d.numAvail == null) return 'nodata';
  if (d.numAvail > 0) return 'open';
  return booked >= units ? 'soldout' : 'closed';
};

export const STATUS_STYLE = {
  open: 'bg-emerald-600 text-white',
  soldout: 'bg-amber-500 text-white',
  closed: 'bg-red-600 text-white',
  nodata: 'bg-slate-200 text-slate-500',
};
export const STATUS_LABEL = { open: 'Open', soldout: 'Sold out', closed: 'Closed', nodata: 'No rate loaded' };

// Merge consecutive days with the same status into colSpan runs (Booking.com draws one bar per run).
export const statusRuns = (days, room) => {
  const runs = [];
  days.forEach((iso) => {
    const st = dayStatus(room.days[iso], room.booked[iso] || 0, room.units);
    const last = runs[runs.length - 1];
    if (last && last.status === st) { last.span += 1; last.to = iso; } else runs.push({ status: st, span: 1, from: iso, to: iso });
  });
  return runs;
};

// Booking.com "Possible issues": nights without a rate or with zero rooms to sell although nothing is booked.
export const roomIssues = (days, room) => days.filter((iso) => {
  const d = room.days[iso];
  return !d || d.price1 == null || (d.numAvail === 0 && (room.booked[iso] || 0) < room.units);
}).length;
